import { Stack } from '@mantine/core';
import { VSelect } from '@vision/ui/components';
import {
  ReportChartCustomizeConfigurationScoreboardRankingCriteria,
  ReportsDetailGraphicSchemaValues,
} from '@vision/ui/interfaces';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const SCOREBOARD_RANKING_DEFAULT: ReportChartCustomizeConfigurationScoreboardRankingCriteria = 'csat';

export function CardChart1ValueComponent() {
  const { t } = useTranslation('page-reports');
  const formik = useFormikContext<ReportsDetailGraphicSchemaValues>();

  const rankingCriteriaSelectItems = useMemo(() => {
    return [
      {
        value: 'csat',
        label: t('scoreboardRankingCriteriaOption.csat'),
      },
      {
        value: 'nps',
        label: t('scoreboardRankingCriteriaOption.nps'),
      },
    ];
  }, [t]);

  if (formik.values.selectedMeasure !== 'feedback-scoreboard') {
    return null;
  }

  const selectedRankingCriteria =
    formik.values.selectedCustomize?.scoreboardRankingCriteria || SCOREBOARD_RANKING_DEFAULT;

  const handleChangeRankingCriteria = (value: string) => {
    formik.setFieldValue('selectedCustomize.scoreboardRankingCriteria', value || SCOREBOARD_RANKING_DEFAULT);
  };

  return (
    <Stack gap={10}>
      <VSelect
        data-testid="input-card-chart-scoreboard-ranking-criteria"
        id="input-card-chart-scoreboard-ranking-criteria"
        label={t('scoreboardRankingCriteria')}
        data={rankingCriteriaSelectItems}
        value={selectedRankingCriteria}
        onChange={handleChangeRankingCriteria}
        clearable={false}
      />
    </Stack>
  );
}
